import parse from "html-react-parser";
import DOMPurify from "dompurify";

const htmlSafe = (string: string): string | JSX.Element | JSX.Element[] => {
  return parse(DOMPurify.sanitize(string, { ADD_ATTR: ["target"] }));
};

export default htmlSafe;
